import { render, staticRenderFns } from "./VariantsSelector.vue?vue&type=template&id=e65ff35a"
import script from "./VariantsSelector.vue?vue&type=script&lang=js"
export * from "./VariantsSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports